// extracted by mini-css-extract-plugin
export var popupContainer = "HotspotPopup-module--popupContainer--2t9Kn";
export var mediaContainer = "HotspotPopup-module--mediaContainer--D_Ioa";
export var textContainer = "HotspotPopup-module--textContainer--1RlIf";
export var titleWrapper = "HotspotPopup-module--titleWrapper--SNsbG";
export var closeButton = "HotspotPopup-module--closeButton--2bxJV";